import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSidebarManager } from "@/hooks/useSidebarManager";
import homeIcon from "@/assets/ navbottom/home (1).png";
import analyticsIcon from "@/assets/ navbottom/graph.png";
import chatsIcon from "@/assets/ navbottom/sms.png";
import exploreIcon from "@/assets/ navbottom/search-normal.png";
import profileIcon from "@/assets/ navbottom/user.png";
import "./NavBottom.css";

const NavBottom = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { messagesSidebarOpen } = useSidebarManager();

  const visibleRoutes = [
    "/dashboard",
    "/messages",
    "/profile",
    "/explore",
    "/search"
  ];

  // Check if we're on the messages page
  const isMessagesPage = location.pathname === "/messages" || location.pathname.startsWith("/messages/");
  
  // Check if we're on mobile
  const isMobile = window.innerWidth <= 768;
  
  // For messages page on mobile, always show NavBottom
  // For messages page on desktop, only show when sidebar is open
  // For other pages, show based on visibleRoutes
  const shouldShow = isMessagesPage 
    ? true
    : visibleRoutes.some(route => 
        location.pathname === route || location.pathname.startsWith(route + "/")
      );

  useEffect(() => {
    if (shouldShow) {
      document.body.classList.add("show-nav-bottom");
    } else {
      document.body.classList.remove("show-nav-bottom");
    }
  }, [shouldShow]);

  if (!shouldShow) {
    return null;
  }

  const navItems = [
    {
      id: "home",
      label: t("navBottom.home", "Home"),
      icon: homeIcon,
      path: "/dashboard",
    },
    {
      id: "analytics",
      label: t("navBottom.analytics", "Explore"),
      icon: analyticsIcon,
      path: "/explore",
    },
    {
      id: "chats",
      label: t("navBottom.chats", "Chats"),
      icon: chatsIcon,
      path: "/messages",
    },
    {
      id: "search",
      label: t("navBottom.search", "Search"),
      icon: exploreIcon,
      path: "/search",
    },
    {
      id: "profile",
      label: t("navBottom.profile", "Profile"),
      icon: profileIcon,
      path: "/profile",
    },
  ];

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  const handleNavClick = (e, path) => {
    e.preventDefault();
    
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    
    navigate(path);
  };

  return (
    <nav className="nav-bottom">
      <div className="nav-bottom__container">
        {navItems.map((item) => (
          <Link
            key={item.id}
            to={item.path}
            onClick={(e) => handleNavClick(e, item.path)}
            className={`nav-bottom__item ${isActive(item.path) ? "nav-bottom__item--active" : ""}`}
          >
            <div className="nav-bottom__icon">
              <img src={item.icon} alt={item.label} />
            </div>
            <span className="nav-bottom__label">{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default NavBottom;
